import React from 'react';
import Top from '../Top';
import About from '../About';
import Works from '../Works';
import Contact from '../Contact';
import Footer from '../Footer';
import Opening from '../Opening';


const Home = () => {
  return (
    <>
      <Top />
      <About />
      <Works />
      <Contact />
      <Footer />
    </>
  )
}

export default Home;